import { DEVICE_STATUS_COLORS } from '../lib/api';

interface StatusBadgeProps {
  status?: string;
}

export const StatusBadge = ({ status }: StatusBadgeProps) => (
  <span className={`px-2 py-1 rounded-full text-xs text-white ${DEVICE_STATUS_COLORS[status || ''] || DEVICE_STATUS_COLORS.unknown}`}>
    {status || 'unknown'}
  </span>
);
